/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTerminalDto
 */
export interface GetTerminalDto {
    /**
     * 
     * @type {GetTerminalDtoLatestStateEnum}
     * @memberof GetTerminalDto
     */
    latestState: GetTerminalDtoLatestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    pspTerminalId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    batteryLevel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    name?: string | null;
}


/**
 * @export
 */
export const GetTerminalDtoLatestStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type GetTerminalDtoLatestStateEnum = typeof GetTerminalDtoLatestStateEnum[keyof typeof GetTerminalDtoLatestStateEnum];


/**
 * Check if a given object implements the GetTerminalDto interface.
 */
export function instanceOfGetTerminalDto(value: object): value is GetTerminalDto {
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    return true;
}

export function GetTerminalDtoFromJSON(json: any): GetTerminalDto {
    return GetTerminalDtoFromJSONTyped(json, false);
}

export function GetTerminalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTerminalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'latestState': json['latestState'],
        'pspTerminalId': json['pspTerminalId'],
        'batteryLevel': json['batteryLevel'] === undefined ? undefined : json['batteryLevel'] === null ? null : json['batteryLevel'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
    };
}

export function GetTerminalDtoToJSON(json: any): GetTerminalDto {
    return GetTerminalDtoToJSONTyped(json, false);
}

export function GetTerminalDtoToJSONTyped(value?: GetTerminalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latestState': value['latestState'],
        'pspTerminalId': value['pspTerminalId'],
        'batteryLevel': value['batteryLevel'],
        'name': value['name'],
    };
}

